import { useEffect } from 'react';
import clsx from 'clsx';
import { useGetContactsStore } from '@lib/store';

interface IContactsProps {
  className?: string;
}

export const Contacts = (props: IContactsProps) => {
  const { data, get } = useGetContactsStore();

  useEffect(() => {
    get();
  }, []);

  if (!data) return null;
  return (
    <div className={clsx('mt-12.5 text-center', props.className)}>
      <p className='text-[#c4c4c4]'>
        International line: <span className='text-[#fff]'>{data.Phone1}</span>
      </p>
      <p className='text-[#c4c4c4]'>
        UK toll free line: <span className='text-[#fff]'>{data.Phone2}</span>
      </p>
      <p className='text-[#c4c4c4]'>
        Email us:{' '}
        <a className='text-[#fff]' href={`mailto:${data.Email}`}>
          {data.Email}
        </a>
      </p>
    </div>
  );
};
